// Texto 21 (B1/B4): o cartão "Enviar para o My Planner" (a lista inteira, inclusive os itens novos) só continua em
// Finanças (contas), Professor (cobranças da turma) e Consultório (recebimentos). Nas outras abas o envio é item por
// item (⋮ do item, "Salvar e colocar no My Planner" ou selecionar vários). As listas que estavam enviadas inteiras
// saem do My Planner (mesmo critério de Cursos, texto 15 B2): nada é apagado, só deixam de aparecer lá.
import { Alert } from 'react-native';
import { getDoc, setDoc } from '../store/store';
import type { AbaId, ModId } from '../store/types';
import { MOD_IDS } from '../store/types';
import { DEFS } from '../modulos/defs';
import { regsDe } from '../store/modulos';
import { aba as abaDe } from '../components/theme';
import { LISTA_CONTAS, LISTA_ITENS } from './enviarPlanner';
import { t } from './i18n';

/** Onde a lista inteira ainda pode ir para o My Planner. */
export function listaInteiraPermitida(aba: AbaId, lista: string) {
  return (aba === 'financas' && lista === LISTA_CONTAS) || (aba === 'professor' && lista === 'cobranca') || (aba === 'consultorio' && lista === 'recebimento')
    || (aba === 'clientes' && lista === 'receb')   // texto 25 (D10)
    || (aba === 'consultorio' && lista === 'atendimento');   // texto 28 (C3): só os valores a receber dos pacientes
}

/** Tira do My Planner as listas inteiras que não podem mais ir; avisa uma vez quais abas e quantos itens. */
export function migrarListasTexto21() {
  const aj = getDoc('ajustes');
  const tirar: { aba: AbaId; lista: string; n: number; nome: string }[] = [];
  for (const [aba, listas] of Object.entries(aj.noPlanner ?? {}) as [AbaId, string[]][]) {
    for (const lista of listas ?? []) {
      if (listaInteiraPermitida(aba, lista)) continue;
      let n = 0, nome = abaDe(aba)?.nome ?? aba;
      if (lista === LISTA_ITENS && (aba === 'documentos' || aba === 'garantias')) n = (getDoc(aba)?.items ?? []).length;
      else if ((MOD_IDS as string[]).includes(aba)) {
        const col = DEFS[aba as ModId]?.colecoes.find(c => c.id === lista);
        n = regsDe(aba as ModId).filter(r => r.col === lista).length;
        if (col) nome = `${nome} › ${t(col.nome)}`;
      }
      tirar.push({ aba, lista, n, nome });
    }
  }
  if (!tirar.length) return;
  setDoc('ajustes', d => {
    const np = { ...(d.noPlanner ?? {}) };
    for (const x of tirar) np[x.aba] = (np[x.aba] ?? []).filter(l => l !== x.lista);
    return { ...d, noPlanner: np };
  });
  const total = tirar.reduce((s, x) => s + x.n, 0);
  setTimeout(() => Alert.alert(t('Envio para o My Planner'),
    t('Agora o envio é item por item (pelo ⋮ do item ou selecionando vários). Estas listas iam inteiras e saíram do My Planner ({n} item(ns), nada foi apagado):', { n: total })
      + '\n\n' + tirar.map(x => `• ${x.nome} (${x.n})`).join('\n')), 1500);
}
